export function InlineCode(props: { children: React.ReactNode }) {
	return <span className="command-example--inline">{props.children}</span>;
}
